var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStartVideo = function SvgStartVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 68,
    viewBox: "0 0 83 68"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_41904",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 41904",
    transform: "translate(-783 -1171)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_2247",
    "data-name": "\\u9577\\u65B9\\u5F62 2247",
    width: 83,
    height: 68,
    rx: 7,
    transform: "translate(783 1171)",
    fill: "#676767",
    opacity: 0.551
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u591A\\u89D2\\u5F62_49",
    "data-name": "\\u591A\\u89D2\\u5F62 49",
    d: "M20.527,6.078a4,4,0,0,1,6.946,0L44.58,36.015A4,4,0,0,1,41.107,42H6.893A4,4,0,0,1,3.42,36.015Z",
    transform: "translate(850 1181) rotate(90)",
    fill: "#fff"
  }))));
};
export default SvgStartVideo;